function isElementInViewport(el) {
  var rect = el.getBoundingClientRect();
  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
    rect.right <= (window.innerWidth || document.documentElement.clientWidth)
  );
}

var videos = document.querySelectorAll('.video-section .custom_video');

function handleVideoPlayPause() {
  videos.forEach(function(video) {
    var videoContainer = video.closest('.video-section__media');

    if (isElementInViewport(videoContainer)) {
      video.play();
    } else {
      video.pause();
    }
  });
}

window.addEventListener('scroll', handleVideoPlayPause);

handleVideoPlayPause();